import React, { useState } from "react";
import { ActionIcon, Menu } from "@mantine/core";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
const PassengerDropdown = ({ items, setPassengers }: any) => {
  const [total, setTotal] = useState(1);
  const handle = (label: any, h: number) => {
    console.log("label: ", label);
    console.log("number: ", h);
    let data = items.map((item: { label: any; count: number }) => {
      if (item.label === label) {
        return { ...item, count: item.count + h };
      }
      console.warn("ITEM: ", item);

      return item;
    });
    setPassengers(data);
  };

  const handleClose = () => {
    let result = items.reduce((sum: any, item: any) => sum + item.count, 0);
    setTotal(result);
  };

  return (
    <Menu onClose={handleClose} width={270} shadow="md" radius="lg">
      <Menu.Target>
        <span className="cursor-pointer text-sm pb-1 font-medium flex items-center gap-x-3">
          <p className="text-gray-500">{total} passenger(s)</p>
          <ExpandMoreIcon />
        </span>
      </Menu.Target>
      <Menu.Dropdown py="md" px="md">
        {items.map((item: any, i: any) => (
          <Menu.Item
            key={i}
            component="div"
            closeMenuOnClick={false}
            className="rounded-none border-b my-1 py-4 border-solid border-gray-200 last:border-0">
            <div className="flex justify-between">
              <div className="">
                <p className="text-gray-600 !font-medium">{item.label}</p>
                <p className="text-gray-400 text-xs">{item.caption}</p>
              </div>
              <span className="flex items-center gap-x-3">
                <ActionIcon
                  disabled={item.count === 0}
                  size="lg"
                  radius="xl"
                  variant="outline"
                  onClick={() => handle(item.label, -1)}>
                  <RemoveIcon />
                </ActionIcon>
                <p className="font-medium text-gray-500">{item.count}</p>
                <ActionIcon
                  size="lg"
                  radius="xl"
                  variant="outline"
                  onClick={() => handle(item.label, 1)}>
                  <AddIcon />
                </ActionIcon>
              </span>
            </div>
          </Menu.Item>
        ))}
      </Menu.Dropdown>
    </Menu>
  );
};

export default PassengerDropdown;
